export default "__VITE_ASSET__ea69fb34__"